import { Component } from "react";

// common components
import SlidingTextButton from "../SlidingTextButton/SlidingTextButton";

// hooks
import { useLanguage } from "lang/Translate";
import { useLogOut } from "components/auth/LogOut";

// styles
import "./ErrorBoundary.scoped.scss";

class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	refresh = () => window.location.reload(true);

	render() {
		if (this.state.hasError) {
			return (
				<div className={`loader ${this.props.isChristmas ? "loader--christmas" : ""}`}>
					<div className="message" style={{ zIndex: 200, fontSize: "1.5rem" }}>
						<p className="error">
							{this.props.lang === "PL" ? "Wystąpił nieoczekiwany błąd" : "An unexpected error has occurred"}
						</p>
						<p className="space-2">
							{this.props.lang === "PL" ? "Proszę spróbować ponownie później." : "Please try again later."}
						</p>

						<SlidingTextButton
							text={this.props.lang === "PL" ? "Odśwież" : "Refresh"}
							icon={<i className="fas fa-arrow-rotate-right icon" />}
							background="darkBlue"
							onClick={this.refresh}
						/>

						<br />

						<Btn />
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}

function Btn() {
	const lang = useLanguage();
	const { signOut: logOut } = useLogOut();

	return (
		<SlidingTextButton
			text={lang === "PL" ? "Wyloguj" : "Log out"}
			icon={<i className="fas fa-sign-out-alt icon" />}
			background="darkBlue"
			onClick={logOut}
		/>
	);
}

export default ErrorBoundary;
